<div class="p-4 pb-3">
	<div class="d-flex align-items-center gap-2 mb-3 fw-semibold fs-5">
		<mat-icon class="font-size">save
			<!-- {{ data?.mode === 'warn' ? 'warning' : 'save' }} -->
		</mat-icon>
		<span class="font-wt">
			 Save Changes As Draft 
			<!-- {{ data?.mode === 'warn' ? 'Unsaved Changes' : 'Save Changes As Draft' }} -->
		</span>
	</div>

	<div class="dialog-divider"></div>
	<div class="col-md-12 col-lg-12 modalBody mb-4 text-md-center">
		Do you want to save Request as Draft?
	</div>
	<div class="d-flex justify-content-center gap-3">
		<button (click)="close('yes')" class="view">
			Yes
		</button>
		<button (click)="close('no')" class="view">
			No		
		</button>
		<!-- <button *ngIf="data?.mode === 'draft'" (click)="close('cancel')" class="view"> -->
        <button (click)="close('cancel')" class="view">
			Cancel
		</button>
	</div>
</div>
